import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import MenuList from './components/MenuList';
import MobileMenu from './components/MobileMenu';
import MobileMenuButton from './components/MobileMenuBtn';
import MobileMenuCloseBtn from './components/MobileMenuCloseBtn';
import * as S from './style';

import { View } from '@/styles/reactnative.tsx';
import { ThemeContext } from '@/theme/ThemeProvider';
import { getMenu } from '@app/constants/Qmenu.tsx';
import { useToken } from '@app/hooks';
import CurrencyModal from '@app/organisms/Footer/CurrencyChange/CurrencyModal';
import AuthHeaderMenu from '@app/organisms/Header/AuthHeaderMenu';
import HeaderSearch from '@app/organisms/Header/HeaderSearch';
import SignUpButton from '@app/organisms/QHome/commons/button/SignUpButton';
import { CModal } from '@components/Common';
import styled from 'styled-components';
import BtnLanguageChange from '../../../organisms/Header/BtnLanguageChange';
import LightCurrency from './assets/light_currency.svg?react';
import DarkCurrency from './assets/dark_currency.svg?react';
import LightMoon from './assets/light_moon.svg?react';
import DarkMoon from './assets/dark_moon.svg?react';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';

function Header({
  themeToggler,
  smallHeader,
  noFloat,
  noPadding,
}: {
  themeToggler: () => void;
  smallHeader?: boolean;
  noFloat?: boolean;
  noPadding?: boolean;
}) {
  const [isMenu, setIsMenu] = useState(false);
  const { i18n } = useTranslation();
  // 언어 변경을 감지하기 위한 state
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);
  // 언어 변경 시 메뉴 업데이트를 위한 state
  const [menuItems, setMenuItems] = useState(getMenu());
  const location = useLocation();
  const path = location.pathname.split('/')[1] || '';
  const isHome = path === '';
  const isCompetitionDetail = path.startsWith('trade-competition');

  const [showCurrencyModal, setShowCurrencyModal] = useState(false);
  const closeCurrencyModal = () =>
    setShowCurrencyModal && setShowCurrencyModal(false);
  const openCurrencyModal = () => {
    setShowCurrencyModal(true);
  };

  const { token } = useToken();
  const { isDarkMode, toggleTheme } = useContext(ThemeContext);
  const theme = isDarkMode ? 'dark' : 'light';

  // 언어 변경 감지
  useEffect(() => {
    if (currentLanguage !== i18n.language) {
      setCurrentLanguage(i18n.language);
      // 언어가 변경되면 메뉴 아이템 업데이트
      setMenuItems(getMenu());
      console.log('언어가 변경되어 메뉴를 업데이트합니다:', i18n.language);
    }
  }, [i18n.language, currentLanguage]);

  useEffect(() => {
    setIsMenu(false);
  }, [location.pathname, location.hash, setIsMenu]);

  const handleToggleMenu = () => {
    setIsMenu((prev) => !prev);
  };

  return (
    <>
      {!noFloat && !isHome && (
        <View
          style={{
            width: 100,
            height: smallHeader ? 50 : 68,
          }}
        />
      )}

      <S.Container
        id='header-container'
        $isHome={isHome}
        $isDarkMode={isDarkMode}
        style={{
          height: smallHeader ? 50 : 68,
          position: noFloat ? 'relative' : 'fixed',
        }}
      >
        {/*  모바일 Drawer  */}
        {isMenu && <MobileMenu />}

        <S.HeaderWrapper
          ref={(node) => {
            if (node) {
              if (noPadding) {
                node.style.setProperty('padding', '0px 10px', 'important');
              }
            }
          }}
          style={{
            height: noPadding ? 'auto' : smallHeader ? 50 : 68,
            maxWidth: smallHeader ? '100%' : '100%',
            padding: noPadding ? '0 10px' : smallHeader ? '0 20px' : '0 60px',
          }}
        >
          <S.LogoContainer>
            <Link to="/">
              {theme === 'light' ? (
                <img src="/images/Qbit/logo-light.png" alt="Logo" />
              ) : (
                <img src="/images/Qbit/logo-dark.png" alt="Logo" />
              )}
            </Link>
          </S.LogoContainer>
          <S.MenuBox style={{ height: 'auto', width: '100%', paddingLeft: 75 }}>
            {menuItems.map((menu) => (
              <MenuList key={menu.title} menu={menu} />
            ))}
          </S.MenuBox>
          <S.RightBox>
            <HeaderSearch />
            {/* <S.SearchInput>
							<span>Q</span>
							<input placeholder="Search" />
						</S.SearchInput> */}

            {token ? (
              <AuthHeaderMenu />
            ) : (
              <S.ButtonBox>
                <S.LoginButton to="/login">{t('login')}</S.LoginButton>
                <SignUpButton />
              </S.ButtonBox>
            )}
            <S.subMenuBox>
              {/* <Qrcode
                marginBottom={0}
                icon={
                  <button style={{}}>
                    {" "}
                    <Download />
                  </button>
                }
              /> */}

              {/*<button>*/}
              {/*  <IconCurrencyDollar color={theme === "light" ? "#000" : "#fff"} size={19}/>*/}
              {/*</button>*/}
              {/*<button>*/}
              {/*  <BtnLanguageChange />*/}
              {/*</button>*/}
              {/*<button onClick={themeToggler}>*/}
              {/*  <LightIcon />*/}
              {/*</button>*/}

              <UtilButton onClick={openCurrencyModal}>
                {theme === 'light' ? <LightCurrency /> : <DarkCurrency />}
              </UtilButton>

              <CModal
                visible={showCurrencyModal}
                onClose={closeCurrencyModal}
                bgColor={'transparent'}
                isResponsive
              >
                <CurrencyModal closeModal={closeCurrencyModal} />
              </CModal>

              <UtilButton>
                <BtnLanguageChange />
              </UtilButton>

              {!isCompetitionDetail && <UtilButton onClick={themeToggler}>
                {theme === 'light' ? <LightMoon /> : <DarkMoon />}
              </UtilButton>}
            </S.subMenuBox>
          </S.RightBox>
        </S.HeaderWrapper>
        {isMenu ? (
          <MobileMenuCloseBtn handleToggleMenu={handleToggleMenu} />
        ) : (
          <MobileMenuButton handleToggleMenu={handleToggleMenu} />
        )}
      </S.Container>
    </>
  );
}

export default React.memo(Header);

const UtilButton = styled.div`
  width: 36px;
  height: 36px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const IconSVG = styled.svg`
  width: 20px;
  height: 20px;
`;
